import { useState } from 'react';
import { SpinnerWheel, useSpinnerWheelState } from '@firstform/spinnerwheel';
import type { LayoutVariant, ColorTheme } from '@firstform/spinnerwheel';

const COLOR_THEMES: ColorTheme[] = [
  'default', 'rainbow', 'sunset', 'ocean', 'forest', 'candy',
  'neon', 'pastel', 'blues', 'reds', 'greens', 'earth', 'retro'
];

function App() {
  const [layout, setLayout] = useState<LayoutVariant>('table');
  const [colorTheme, setColorTheme] = useState<ColorTheme>('default');

  const wheel = useSpinnerWheelState({
    initialEntries: [
      { id: '1', name: 'Pizza' },
      { id: '2', name: 'Burger' },
      { id: '3', name: 'Sushi' },
      { id: '4', name: 'Tacos' },
      { id: '5', name: 'Pasta' },
      { id: '6', name: 'Salad' },
    ],
    syncToUrl: true,
    onWinnerSelected: (winner) => {
      console.log('Winner selected:', winner.name);
    },
  });

  return (
    <div className="demo-app">
      <header className="demo-header">
        <h1>Spinner Wheel Demo</h1>
        <p>A React + TypeScript spinner wheel component</p>
        <div className="controls-row">
          <div className="layout-toggle">
            <span>Layout:</span>
            <button
              className={`toggle-btn ${layout === 'default' ? 'active' : ''}`}
              onClick={() => setLayout('default')}
            >
              Default
            </button>
            <button
              className={`toggle-btn ${layout === 'table' ? 'active' : ''}`}
              onClick={() => setLayout('table')}
            >
              Table
            </button>
          </div>
          <div className="theme-select">
            <span>Color Theme:</span>
            <select
              value={colorTheme}
              onChange={(e) => setColorTheme(e.target.value as ColorTheme)}
            >
              {COLOR_THEMES.map((theme) => (
                <option key={theme} value={theme}>
                  {theme.charAt(0).toUpperCase() + theme.slice(1)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </header>

      <main className="demo-content">
        <SpinnerWheel
          entries={wheel.entries}
          isSpinning={wheel.isSpinning}
          winner={wheel.winner}
          currentSegment={wheel.currentSegment}
          showWinnerPopup={wheel.showWinnerPopup}
          onEntriesChange={wheel.setEntries}
          onSpin={wheel.spin}
          onSpinComplete={wheel.handleSpinComplete}
          onSegmentChange={wheel.handleSegmentChange}
          onWinnerPopupClose={wheel.closeWinnerPopup}
          layout={layout}
          colorTheme={colorTheme}
          audioEnabled={true}
          confettiEnabled={true}
        />
      </main>

      <footer className="demo-footer">
        <p>
          Built with{' '}
          <a href="https://react.dev" target="_blank" rel="noopener noreferrer">
            React
          </a>{' '}
          +{' '}
          <a href="https://www.typescriptlang.org" target="_blank" rel="noopener noreferrer">
            TypeScript
          </a>
        </p>
      </footer>
    </div>
  );
}

export default App;
